export const GET_DATE_WISE_PRODUCTIONS = 'GET_DATE_WISE_PRODUCTIONS';
export const GET_DATE_WISE_PRODUCTIONS_PAGE = 'GET_DATE_WISE_PRODUCTIONS_PAGE';
export const DATE_WISE_PRODUCTION_REQUEST = 'DATE_WISE_PRODUCTION_REQUEST';
export const CREATE_DATE_WISE_PRODUCTION = 'CREATE_DATE_WISE_PRODUCTION';
export const UPDATE_DATE_WISE_PRODUCTION = 'UPDATE_DATE_WISE_PRODUCTION';
export const DELETE_DATE_WISE_PRODUCTION = 'DELETE_DATE_WISE_PRODUCTION';
export const DATE_WISE_PRODUCTION_REQUEST_FAILURE = 'DATE_WISE_PRODUCTION_REQUEST_FAILURE';
export const GET_DATE_WISE_PRODUCTIONS_WITH_DETAIL = 'GET_DATE_WISE_PRODUCTIONS_WITH_DETAIL';
export const DATE_WISE_PRODUCTION_REQUEST_SUCCESS  = 'DATE_WISE_PRODUCTION_REQUEST_SUCCESS';